import { StorageService } from "../storage.service";
import { getInitials } from "./get-initials";
import { AvatarCircle } from "./style";

export const UserAvatar = ({ size = 36 }: { size?: number }) => {
    const user = StorageService.getUsers();
    console.log(user);
    const name = user?.name?.trim();

    if (!name) {
        return null;
    }

    const initials = getInitials(name);
    if (!initials) {
        return null;
    }

    return (
        <AvatarCircle aria-label={name} title={name} $size={size}>
            {initials}
        </AvatarCircle>
    );
};
